<section class="chart-bar-general">
    <div class="activity-theme">
        <svg class="svg" focusable="false" aria-hidden="true" role="presentation"></svg>
    </div>
</section>
